'use strict';

// @see https://www.typescriptlang.org/docs/handbook/advanced-types.html#exhaustiveness-checking
/* istanbul ignore next */
function assertUnreachable(value) {
  throw new TypeError("Unreachable value reached " + value);
}
exports.assertUnreachable = assertUnreachable;